import { render, staticRenderFns } from "./historicDetail.vue?vue&type=template&id=6c345a4e&"
import script from "./historicDetail.vue?vue&type=script&lang=js&"
export * from "./historicDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports